<template>
	<b-overlay :show="is_load">
		<div class="categ_list p-5" v-if="this.tree.length > 0">
			<categlist_product  :categories="tree" @change="on_set"></categlist_product>
		</div>
	</b-overlay>
</template>

<script>
import Categlist_product from "../../../categories/list/categlist_product";
export default {
	name: "product_categories",
	components: {Categlist_product},
	props : {
		product : {
			type : Object
		}
	},

	created () {
		this.load_categs();
	},

	data() {
		return {
			is_load: true,
			tree : [],
		}
	},

	methods : {
		on_set(categs) {
			console.log("set_categ",categs);

			this.cur_prod_categories = categs;
		},

		async load_categs () {
			this.is_load = true;
			this.tree = [];
			await api.post('/internal/v1/catalog/categories/tree', {
                'org_id': this.product.restaurant_id
            }).then(({data}) => {
				this.is_load = false;
				if (data.status === "operation_success") {
					 this.set_tree(data.data);
				}
			}).catch(({response}) => {
				this.is_load = false;
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
			});
		},

        set_tree(tree_categ)
        {
            this.set_tree_atributes(tree_categ);
            this.tree = tree_categ;
        },

        set_tree_atributes(tree) {
		    let self = this;

            tree.map(item => {
                item.show_children = false;
                item.is_selected = false;
                item.is_selected_main  = false;

                if(self.cur_prod_categories.length > 0) {
                    self.cur_prod_categories.map(active_item => {
                        if(parseInt(active_item.category_id) === parseInt(item.id)) {
                            item.is_selected = true;
                            item.is_selected_main = active_item.is_default;
                        }
                    });
                }
                if(item.hasOwnProperty("children") && item.children.length > 0) {
                    self.set_tree_atributes(item.children);
                }
            });
        }
	},

	computed : {

	    cur_prod_categories : {
	        get : function() {
                if(this.product.hasOwnProperty("current_categories")) {
                    return this.product.current_categories;
                }
                return [];
            },
            set : function(categs) {
                this.product.current_categories = [];
                categs.map(item => {
                    let to_push = {
                        "id": 0,
                        "category_id": parseInt(item.id),
                        "is_default": item.is_selected_main
                    };
                    this.product.current_categories.push(to_push);
                });
            }
        },

	},
}
</script>

<style scoped>

</style>
